import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import InputDate from "../../helpers/InputDate";
import InputDecimal from "../../helpers/InputDecimal";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import SortBy from "../../helpers/SortBy";
import FormatDecimal from "../../helpers/FormatDecimal";
import MenuTable from "../../helpers/MenuTable";
import InputCombo from "../../helpers/InputCombo";
import FormatAccount from "../../helpers/FormatAccount";
import InputTextArea from "../../helpers/InputTextArea";


function KSeF(props)
{

   // var dt = new Date();
   // dt = dt.toLocaleDateString('en-CA');
   // dt = "" + dt.substring(0,7) + "-01";

    const now = new Date();
    // odejmij 3 miesiące
    now.setMonth(now.getMonth() - 2);
    // format YYYY-MM-DD
   const dt = now.toISOString().split('T')[0];

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({

        numer_dokumentu:   props.mainView.readFilter('inv_numer_dokumentu',''),   
        data_wystawienia_od:  props.mainView.readFilter('inv_data_wystawienia_od',   dt),   
        data_wystawienia_do:  props.mainView.readFilter('inv_data_wystawienia_do',''),   
        ksef_numer: props.mainView.readFilter('inv_ksef_numer',''),  
        nip: props.mainView.readFilter('inv_nip',''),  
        sprzedawca: props.mainView.readFilter('inv_sprzedawca',''),  

        brutto_od:        props.mainView.readFilter('inv_brutto_od',''),   
        brutto_do:        props.mainView.readFilter('inv_brutto_do',''),  

        status:           props.mainView.readFilter('status','_x_'),  
        data_przelewu_od:    props.mainView.readFilter('data_przelewu_od',''),  
        data_przelewu_do:    props.mainView.readFilter('data_przelewu_do',''),  


        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 500,
        page: 1,
        pages: 1,
        show: true,
     });

    
    const [tab, setTab] = useState(null);

    const [view, setView] = useState ( "list");

    const [invoice, setInvoice] = useState ( null );
    const [kNumer, setKNumer] = useState("");


    const [legend, setLegend] = useState([

        {
            cls:'color_show4',
            title: 'dokument przyjęty',
           filter: {  filed: "status", set: "zatwierdzona", typ: "combo"  },
        }, 

        {
            cls:'color_show5',
            title: 'dokument opłacony',
           filter: {  filed: "status", set: "oplacona", typ: "combo"  },
        },  
        {
            cls:'color_deleted2',
            title: 'dokument odrzucony',
           filter: {  filed: "status", set: "oplacona", typ: "combo"  },
        },       
    ]);


    const valChangeListener = (filedName, val, correct, msg) => {

        
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );      
            
            /*
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }*/
        
            props.mainView.writeFilter(filedName, val);            
    }


    const valChangeListener2 = (filedName, val, correct, msg) => {    
            setInvoice( {...invoice, [filedName]:val } );                         
    }



    const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
    }



          const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('inv_numer_dokumentu', '');
            props.mainView.writeFilter('inv_data_wystawienia_od', dt);
            props.mainView.writeFilter('inv_data_wystawienia_do', '');
            props.mainView.writeFilter('inv_ksef_numer', '');
            props.mainView.writeFilter('inv_brutto_od', '');
            props.mainView.writeFilter('inv_brutto_do', '');
            props.mainView.writeFilter('inv_nip', '');
            props.mainView.writeFilter('inv_sprzedawca', '');

            props.mainView.writeFilter('status', '_x_');
            props.mainView.writeFilter('data_przelewu_od', '');
            props.mainView.writeFilter('data_przelewu_do', '');
        
 
            setFilterParam({
           
                numer_dokumentu: '',                                                        
                data_wystawienia_od: dt,                                                        
                data_wystawienia_do: '',                                                        
                ksef_numer: '',                                                        
                brutto_od: '',                                                        
                brutto_do: '',                                                        
                nip: '', 
                sprzedawca: '', 
                status: '_x_', 
                data_przelewu_od: '', 
                data_przelewu_do: '', 
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 200,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }



    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_calc,ksef', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
 
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }


    const showDocument = (row) => {

            var numerKsef = row.numer_ksef;
            setKNumer(numerKsef);


                props.mainView.showProgress();       
 

                fetch( Config.url + '/rest_v1_calc,ksef_invoice', {
                    method: 'POST', 
                    body: JSON.stringify({
                        ksef_numer: numerKsef,
                    }), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                        props.mainView.hideProgress();    

                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                    res.result.id = row.id; 
                                    res.result.status = row.status; 
                                    res.result.data_przelewu = row.data_przelewu; 
                                    res.result.informacje_dodatkowe = row.informacje_dodatkowe; 

                                   // console.log("xcvx", res.result.Fa.Platnosc.TerminPlatnosci);
                                    if(res.result.Fa != undefined && res.result.Fa.Platnosc != undefined &&  res.result.Fa.Platnosc.TerminPlatnosci != undefined  &&  res.result.Fa.Platnosc.TerminPlatnosci.Termin != undefined && (row.data_przelewu == null || row.data_przelewu.length < 3 )   )
                                    {
                                         res.result.data_przelewu = res.result.Fa.Platnosc.TerminPlatnosci.Termin; 
                                    }

                                    //-----------------
                                        var kwota      = res.result.Fa.P_15; //brutto..                                     

                                        if(res.result.sugerowana != undefined) kwota = res.result.sugerowana;

                                        if( res.result.Fa != undefined && res.result.Fa.Rozliczenie != undefined && res.result.Fa.Rozliczenie.DoZaplaty != undefined)
                                        {
                                            kwota = res.result.Fa.Rozliczenie.DoZaplaty;
                                        }

                                        res.result.kwota_koszyk = kwota;

                                    setInvoice(res.result);
                                         
                            }
                } )
                .catch(err => {          
                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                        props.mainView.hideProgress();    
                });


    };


    const addToTrash = () => {


        console.log("Add to trash", invoice);

      //  var kwota      = invoice.Fa.P_15; //brutto..
        var kwota = invoice.kwota_koszyk; //po nowemu..


        var tytul      = invoice.Fa.P_2; //numer dokumentu
        var numer_ksef = kNumer; //numer ksef        
        var numerRachunkuOdbiorcy = '';

        if(invoice.sugerowana != undefined) kwota = invoice.sugerowana;

        if( invoice.Fa != undefined && invoice.Fa.Rozliczenie != undefined && invoice.Fa.Rozliczenie.DoZaplaty != undefined)
        {
          //  kwota = invoice.Fa.Rozliczenie.DoZaplaty;
        }

        if(invoice.Fa.Platnosc != undefined && invoice.Fa.Platnosc.RachunekBankowy != undefined && invoice.Fa.Platnosc.RachunekBankowy.NrRB != undefined )
        {
           numerRachunkuOdbiorcy = invoice.Fa.Platnosc.RachunekBankowy.NrRB;
        }

          


        if(numerRachunkuOdbiorcy.length < 26) return;
        if(tytul.length < 2) return;

        props.mainView.addToTrashTransfer({
            nazwa: invoice.Fa.P_2+"",
            opis: invoice.Podmiot1.DaneIdentyfikacyjne.Nazwa+"",
            kwota: kwota,
            tytul: tytul,
            data: invoice.data_przelewu,
            numer_rach: numerRachunkuOdbiorcy+"",
            numer_ksef: numer_ksef+"",
            full: JSON.parse(JSON.stringify(invoice)),
        });


        setInvoice(null);
        props.mainView.showDialog( "Sukces", "Pozycja została dodana do koszyka"  , "ok" , null);
    }


      const updateInvoice = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_calc,ksef_invoice_update', {
            method: 'POST', 
            body: JSON.stringify(invoice), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                setInvoice(null); 
                getTab(); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }




    const obliczBruttoKSeF = (poz) => {

          

            var stawka = poz.P_12;       

            var ilosc = poz.P_8B;
            var cena_j_netto = poz.P_9A;           
            var stawkProcent = 0;

            stawkProcent = parseInt(stawka);


        

            if(stawka == '0 KR') stawkProcent = 0;
            if(stawka == '0 WDT') stawkProcent = 0;
            if(stawka == '0 EX') stawkProcent = 0;
            if(stawka == 'zw') stawkProcent = 0;
            if(stawka == 'oo') stawkProcent = 0;
            if(stawka == 'np I') stawkProcent = 0;
            if(stawka == 'np II') stawkProcent = 0;
            
            ilosc = parseFloat(ilosc) || 0;
            cena_j_netto = parseFloat(cena_j_netto) || 0;

            var razemNetto = ilosc * cena_j_netto;
            var razemBrutto = razemNetto * (1 + stawkProcent / 100);

            razemBrutto = Math.round(razemBrutto * 100) / 100;


            //podano tylo cene jednostkowa brutto
            if(poz.P_9A == undefined && poz.P_9B) 
            {
                 razemBrutto = parseFloat(poz.P_9B) * ilosc;
                 razemBrutto = Math.round(razemBrutto * 100) / 100;
            }


            return razemBrutto;
    }


    function obliczNetto(poz)
    {
            var cena_j_brutto = poz.P_9B;    
            
            var stawka = poz.P_12;   

            var stawkProcent = parseInt(stawka);
        

            if(stawka == '0 KR') stawkProcent = 0;
            if(stawka == '0 WDT') stawkProcent = 0;
            if(stawka == '0 EX') stawkProcent = 0;
            if(stawka == 'zw') stawkProcent = 0;
            if(stawka == 'oo') stawkProcent = 0;
            if(stawka == 'np I') stawkProcent = 0;
            if(stawka == 'np II') stawkProcent = 0;

            stawkProcent = (stawkProcent / 100); // 0.23
            stawkProcent = Math.round(stawkProcent * 100) / 100;
           
            stawkProcent = 1 + stawkProcent;
        
 
            var netto = cena_j_brutto / stawkProcent;      
            netto = Math.round(netto * 100) / 100;
            return netto;

    }


    


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });            
        setTab(null); 
    
    }



    if(tab == null)
    {
        setTab([]);
        getTab();        
        return <div>
            ...
        </div>
    }

    document.title = "Faktury w KSeF";


    var dialog = null;

    if(invoice != null && invoice.Fa != null)
    {
        console.log("KSeFX", invoice);
        var pozycje = new Array();

        //jesli jest więcej pozycje.. to jest to Array...
        if(invoice.Fa.FaWiersz instanceof Array)
        {
            for(var k=0; k < invoice.Fa.FaWiersz.length; k++)
            {
                pozycje.push( invoice.Fa.FaWiersz[k] );
            }
        }else 
        {
             pozycje.push( invoice.Fa.FaWiersz); 
        }



        console.log("Pozycje", pozycje);

        dialog = <div className="dlg_window dlg_content_white shadowx " >

              <div className="dlg_title">Wizualizacja faktury /  {invoice.Fa.P_2} z dnia {invoice.Fa.P_6} </div>
             
                <div style={{padding: '10px', }} className="">

                    <div>
                        <b>Rodzaj dokumentu</b> {invoice.Fa.RodzajFaktury}
                    </div>
                    <div>
                        <b>Data wystawienia</b> {invoice.Fa.P_1} &nbsp;
                        <b>Data sprzedaży</b> {invoice.Fa.P_6} &nbsp;
                        <b>Netto</b>  <FormatDecimal  value={invoice.Fa.P_13_1}  copy="1"  mainView={props.mainView}/>  &nbsp;
                        <b>Vat</b> <FormatDecimal  value={invoice.Fa.P_14_1} copy="1"  mainView={props.mainView}/> &nbsp;
                        <b>Brutto</b> <FormatDecimal  value={invoice.Fa.P_15} copy="1"  mainView={props.mainView} /> &nbsp;
                    </div>



                    <div>
                        
                        {
                            invoice.Fa.Platnosc != undefined && invoice.Fa.Platnosc.RachunekBankowy != undefined && invoice.Fa.Platnosc.RachunekBankowy.NrRB != undefined &&
                            <Fragment>                                
                                  <b>Numer rachunku do wpła: </b> <FormatAccount value={invoice.Fa.Platnosc.RachunekBankowy.NrRB} /> 
                                  {
                                    invoice.Fa.Platnosc.RachunekBankowy.SWIFT != undefined &&
                                    <Fragment>
                                     &nbsp; &nbsp; <b>SWIFT: </b> {invoice.Fa.Platnosc.RachunekBankowy.SWIFT} {" "}
                                    </Fragment>
                                  }
                            </Fragment>
                        }

                        {
                            invoice.Fa.Platnosc != undefined &&   invoice.Fa.Platnosc.PlatnoscInna != undefined && invoice.Fa.Platnosc.OpisPlatnosci != undefined &&
                            <Fragment> <b> Inna forma płatności: </b> {invoice.Fa.Platnosc.OpisPlatnosci}</Fragment>
                        }
                                          
                        {
                            invoice.Fa.Platnosc != undefined &&   invoice.Fa.Platnosc.FormaPlatnosci != undefined && invoice.Fa.Platnosc.FormaPlatnosci == '1' &&
                            <Fragment><b>Forma płatności: </b> Gotówka</Fragment>
                        }


                        {
                            invoice.Fa.Platnosc != undefined &&   invoice.Fa.Platnosc.Zaplacono != undefined  &&
                            <Fragment><b>Zapłacona: </b> TAK</Fragment>
                        }

                        {
                            ((invoice.Fa.Adnotacje != undefined &&    invoice.Fa.Adnotacje.P_18A != undefined &&  invoice.Fa.Adnotacje.P_18A == '1' ) ) &&
                            <Fragment><b> Split Payment: </b> TAK</Fragment>
                        }

                         {
                            invoice.Fa.Platnosc != undefined &&  invoice.Fa.Platnosc.TerminPlatnosci != undefined &&
                            <Fragment>&nbsp; <b>Termin płatności: </b> {invoice.Fa.Platnosc.TerminPlatnosci.Termin} </Fragment>
                         }
                                                
                    </div> 

                

                    <table className="table">                
                            <tr className="header">
                                <td style={{ textAlign:'center'}}>Sprzedawca</td>
                                <td style={{ textAlign:'center'}}>Nabywca</td>
                                 {
                                      invoice.Podmiot3 != undefined &&    
                                      <td style={{ textAlign:'center'}}>Odbiorca</td>
                                 }                               
                            </tr>
                            <tr>
                                <td style={{ textAlign:'left'}}>
                                    {invoice.Podmiot1.DaneIdentyfikacyjne.NIP} <br/>                        
                                    {invoice.Podmiot1.DaneIdentyfikacyjne.Nazwa}<br/>
                                </td>
                                <td style={{ textAlign:'left'}}>
                                    {invoice.Podmiot2.DaneIdentyfikacyjne.NIP} <br/>                        
                                    {invoice.Podmiot2.DaneIdentyfikacyjne.Nazwa}<br/>
                                </td>

                                {
                                      invoice.Podmiot3 != undefined &&                                      
                                     <td style={{ textAlign:'left'}}>
                                    {
                                        invoice.Podmiot3 != undefined && invoice.Podmiot3.DaneIdentyfikacyjne != undefined &&
                                        <Fragment>
                                            {invoice.Podmiot3.DaneIdentyfikacyjne.NIP} <br/>                        
                                            {invoice.Podmiot3.DaneIdentyfikacyjne.Nazwa}<br/>
                                        </Fragment>
                                    }
                                </td>
                                }                              
                            </tr>
                    </table>

                    <div className="hMax100">
                       
                          <table className="table">                
                             <tr className="header">
                                <td>LP</td>
                                <td>Nazwa</td>
                                <td>JM</td>
                                <td>Ilość</td>
                                <td>Cena j.</td>
                                <td>Stawka</td>
                                <td>Razem</td>
                             </tr>
                              {
                                    pozycje.map((poz, inx) => {

                                     if(poz == undefined)    return null;
                                     if(poz.NrWierszaFa == undefined)    return null;

                                        
                                     var rowStyle = " row ";
                                     if(inx % 2 == 0 )rowStyle = " row2 ";

                                     var  pozycjaBrutto = obliczBruttoKSeF(poz);
                                     var  pozycjaNetto = obliczNetto(poz);

                                     return <tr className={rowStyle} key={inx}>
                                        <td>{poz.NrWierszaFa}</td>
                                        <td>{poz.P_7}</td>
                                        <td className="gocenter">{poz.P_8A}</td>
                                        <td className="goright">{poz.P_8B}</td>

                                        {
                                            poz.P_9A != undefined &&
                                            <td className="goright">{poz.P_9A}</td>
                                        }

                                        {
                                            poz.P_9B != undefined &&
                                            <td className="goright">{pozycjaNetto}</td>
                                        }
                                        

                                        <td className="gocenter">{poz.P_12}</td>
                                        <td className="goright">{pozycjaBrutto}</td>
                                    </tr>

                                    })
                                } 
                          </table>                                         
                    </div>

                    {
                            invoice.Fa.Rozliczenie != undefined &&
                            <div className="">
                                    <br/>
                                    <div className="hMax100">
                                        {
                                            invoice.Fa.Rozliczenie.Obciazenia != undefined &&  invoice.Fa.Rozliczenie.Obciazenia.map != undefined &&
                                            <table className="table">     
                                               <tr className="header">
                                                    <td>Powód</td>
                                                    <td>Kwota</td>                                                                                                   
                                                </tr>  
                                                    {
                                                        invoice.Fa.Rozliczenie.Obciazenia.map((roz, inxRoz) => {

                                                            var rowStyle = " row ";
                                                            if(inxRoz % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={ rowStyle } >
                                                                <td>{roz.Powod}</td> 
                                                                <td className="goright"><FormatDecimal value={roz.Kwota} /></td>                                                                                                           
                                                            </tr> 
                                                        })
                                                    }
                                            </table>
                                        }
                                        {
                                            invoice.Fa.Rozliczenie.Obciazenia != undefined &&  invoice.Fa.Rozliczenie.Obciazenia.map == undefined && invoice.Fa.Rozliczenie.Obciazenia.Kwota != undefined &&
                                            <div>
                                                Kwota:  <FormatDecimal value={invoice.Fa.Rozliczenie.Obciazenia.Kwota} />, &nbsp; Powód: {invoice.Fa.Rozliczenie.Obciazenia.Powod}
                                            </div>                                        
                                        }
                                    </div>
                                    {
                                        invoice.Fa.Rozliczenie.DoZaplaty != undefined &&
                                        <div>
                                            <b>Razem obciążeń : </b> <FormatDecimal  value={invoice.Fa.Rozliczenie.SumaObciazen}  copy="1" mainView={props.mainView} /> 
                                            &nbsp; 
                                            <b>Do zapłaty: </b> <FormatDecimal  value={invoice.Fa.Rozliczenie.DoZaplaty} copy="1"  mainView={props.mainView} />   
                                        </div>
                                    } 
                            </div>
                    }

 

                </div>
                  
  
                 <div>
                                    <div className="filter_controll">   
                                            <label>Status: </label>                             
                                            <InputCombo items={[{v:'_x_', title:' - - - '}, {v:'zatwierdzona', title:'zatwierdzona / przyjęta'},  {v:'oplacona', title:'opłacona'},  {v:'odrzucona', title:'odrzucona'},    ]}   userData={props.userData} value={invoice.status}   valChange={valChangeListener2} goNext={null} name="status" placeholder={"Status: "}   />                                            
                                    </div> 

                                    {
                                        invoice.status == 'oplacona' && 
                                        <div className="filter_controll">   
                                            <label>Data przelewu: </label>                             
                                            <InputDate   userData={props.userData} value={invoice.data_przelewu}   valChange={valChangeListener2} goNext={null} name="data_przelewu" placeholder={"Data przelewu: "}   />                                            
                                        </div> 
                                    }    

                        

                                    <div className="filter_controll">   
                                            <label>Informacje dodatkowe: </label>                             
                                            <InputText   userData={props.userData} value={invoice.informacje_dodatkowe}   valChange={valChangeListener2} goNext={null} name="informacje_dodatkowe" className="w200" placeholder={"Info.: "}   />                                            
                                    </div>    


                                      <div className="filter_controll">   
                                            <label>Kwota do koszyka: </label>                             
                                            <InputDecimal   userData={props.userData} value={invoice.kwota_koszyk}   valChange={valChangeListener2} goNext={null} name="kwota_koszyk" className="w100" placeholder={"Kwota: "}   />                                            
                                    </div> 

                                    <br/>&nbsp; 
                                    
                                  
                                    
                                    <span className="btn" onClick={addToTrash}>Dodaj do koszyka</span>                             
                                    &nbsp;&nbsp;
                                    <span className="btn" onClick={updateInvoice}>Zapisz</span>                             
                 </div>

                 <br/>

              <div style={{padding:'10px', textAlign:'right'}}>
                  <div className="link_normal" onClick={()=>{ setInvoice(null); }}>zamknij</div>
              </div>  
        </div>
    }



    
        var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "data_wystawienia", name: "Data wystawienia"  },           
        ]

 

    return  <div className="view_content">
            
                <h3 className="dash_header">Faktury w KSeF</h3>


                     <div className="table_filter">

                                   <div className="filter_controll">   
                                            <label>Numer dokumentu: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.numer_dokumentu}   valChange={valChangeListener} goNext={goNextNew} name="numer_dokumentu" placeholder={"Numer dokumentu: "}   />                                            
                                    </div> 

                                    <div className="filter_controll">   
                                            <label>Numer KSeF: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.ksef_numer}   valChange={valChangeListener} goNext={goNextNew} name="ksef_numer" placeholder={"Numer KSeF: "}   />
                                    </div> 

                                     <div className="filter_controll">   
                                            <label>NIP sprzedawcy: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                                    </div> 

                                     <div className="filter_controll">   
                                            <label>Nazwa sprzedawcy: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.sprzedawca}   valChange={valChangeListener} goNext={goNextNew} name="sprzedawca" placeholder={"Fraza: "}   />
                                    </div> 


                                    <div className="filter_controll filter_merge">   
                                        <label>Data wystawienia (od dnia / do dnia):   </label>      <br/>                       
                                        <InputDate   userData={props.userData} value={filterParam.data_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_od" placeholder={"Od dnia: "}   />                                                                  
                                        <InputDate   userData={props.userData} value={filterParam.data_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_do" placeholder={"Do dnia: "}   />
                                     </div> 


                                      
                                    <div className="filter_controll filter_merge">   
                                        <label>Brutto (od / do): </label>        
                                        <br/>                     
                                        <InputDecimal userData={props.userData}  mainView={props.mainView}  value={filterParam.brutto_od}   valChange={valChangeListener} goNext={goNextNew} name="brutto_od" placeholder={" "}   />
                                        <InputDecimal  userData={props.userData}  mainView={props.mainView}  value={filterParam.brutto_do}   valChange={valChangeListener} goNext={goNextNew} name="brutto_do" placeholder={" "}   />
                                    </div> 


                                    <div className="filter_controll">   
                                            <label>Status: </label>                             
                                            <InputCombo items={[{v:'_x_', title:' - - - '}, {v:'zatwierdzona', title:'zatwierdzona / przyjęta'},  {v:'oplacona', title:'opłacona'},  {v:'odrzucona', title:'odrzucona'},    ]}   userData={props.userData} value={filterParam.status}   valChange={valChangeListener} goNext={goNextNew} name="status" placeholder={"Status: "}   />                                            
                                    </div> 

                                    
                                    <div className="filter_controll filter_merge">   
                                        <label>Data przelewy / zapłaty (od dnia / do dnia):   </label>      <br/>                       
                                        <InputDate   userData={props.userData} value={filterParam.data_przelewu_od}   valChange={valChangeListener} goNext={goNextNew} name="data_przelewu_od" placeholder={"Od dnia: "}   />                                                                  
                                        <InputDate   userData={props.userData} value={filterParam.data_przelewu_do}   valChange={valChangeListener} goNext={goNextNew} name="data_przelewu_do" placeholder={"Do dnia: "}   />
                                     </div> 



                                    <div className="filter_btn">                       
                                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                                    </div> 
                                    
                     </div>


                       
                <div className="table_widget">
                                                         
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

 

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


                         <div className="bg_center">

                               <table className="table"  >

                                        <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                          
                                                <td>Status</td>                                                                                                                                    
                                                <td>Numer</td>                                                                                                                                    
                                                <td>Numer KSeF</td>                                                                                                                                    
                                                <td>Data</td>
                                                <td>Sprzedawca</td>
                                                <td>NIP</td>                                              
                                                <td>Netto</td>                                              
                                                <td>Vat</td>                                              
                                                <td className="td_right">Razem brutto</td>        
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                            
                                                   {
                                                    tab.map( (row, ix) => {

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                        if(row.status == 'oplacona')      rowStyle = ' color_show5 ';
                                                        if(row.status == 'odrzucona')     rowStyle = ' color_deleted2 ';
                                                        if(row.status == 'zatwierdzona')  rowStyle = ' color_show4 ';

                                                        return <tr className={rowStyle} key={ix}>
                                                                    <td className="gocenter">{ix+1}</td>
                                                                    <td className="gocenter"   onClick={ ()=>{showDocument(row)} } >
                                                                        {row.status == '_x_' && <span>---</span> } 
                                                                        {row.status != '_x_' && <span>{row.status}</span> } 
                                                                    </td>
                                                                    <td className="gocenter"  onClick={ ()=>{showDocument(row)} } >{row.numer} </td>
                                                                    <td className="gocenter"  onClick={ ()=>{showDocument(row)} } >{row.numer_ksef} </td>
                                                                    <td className="gocenter"  onClick={ ()=>{showDocument(row)} } >{row.data_wystawienia} </td>
                                                                    <td className=""  onClick={ ()=>{showDocument(row)} } >{row.sprzedawca} </td>
                                                                    <td className="gocenter"  onClick={ ()=>{showDocument(row)} } >{row.nip} </td>
                                                                    <td className="goright"   onClick={ ()=>{showDocument(row)} }><FormatDecimal value={row.netto}/></td>
                                                                    <td className="goright"   onClick={ ()=>{showDocument(row)} }><FormatDecimal value={row.vat}/></td>
                                                                    <td className="goright"   onClick={ ()=>{showDocument(row)} }><FormatDecimal value={row.brutto}/></td>

                                                                     <MenuTable>
                                                                        <ul>
                                                                            <li   onClick={ ()=>{showDocument(row)} }  > Pokaż </li>
                                                                        </ul>
                                                                     </MenuTable>
                                                        </tr>

                                                    })
                                                   }
                                            

                                        </tbody>

                               </table>

                         </div>

                {dialog}
            </div>
}

export default KSeF;